// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__Tsj4q","endIcon":"Button_endIcon__HPorL","btnLoading":"Button_btnLoading__wN5cF"};